import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import AdjuntoAutoevaluacion from "../AdjuntoAutoevaluacion";

function PerfilAutoevaluacio({ InstitucionId }) {
  const cookies = new Cookies();
  const { id } = useParams();

  const [country, setCountry] = useState([]);
  const [countryId, setCountryId] = useState("");
  const [titles, setTitles] = useState([]);
  const [titleId, setTitleId] = useState("");
  const [subtitles, setSubtitles] = useState([]);
  const [postSubtitle, setPostSubtitle] = useState("");
  const [postDescription, setPostDescription] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const selectStyle = {
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxHeight: "150px",
  };

  const fetchData = async (url, setter) => {
    try {
      const response = await fetch(url);
      const data = await response.json();
      setter(data);
    } catch (error) {
      console.error("Error fetching data: ", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo cargar la información",
      });
    }
  };

  useEffect(() => {
    fetchData(
      "https://suadesarrollo.azurewebsites.net/Api/ObtenerSeccionAutoevaluacion",
      setCountry,
    );
  }, []);

  useEffect(() => {
    if (countryId) {
      setTitles([]);
      setSubtitles([]);
      setTitleId("");
      setPostSubtitle("");
      fetchData(
        `https://suadesarrollo.azurewebsites.net/Api/ObtenerTituloAutoevaluacionPorSeccionId?SeccionId=${countryId}&Tipo=Perfil`,
        setTitles,
      );
    }
  }, [countryId]);

  useEffect(() => {
    if (titleId) {
      setSubtitles([]);
      setPostSubtitle("");
      fetchData(
        `https://suadesarrollo.azurewebsites.net/Api/ObtenerSubTituloAutoevaluacionPorTituloId?TituloId=${titleId}&Tipo=Perfil`,
        setSubtitles,
      );
    }
  }, [titleId]);

  const postData = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    try {
      await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/CreaRegistroPerfilAutoevaluacion",
        {
          Seccion: countryId,
          tituloId: titleId,
          subTitulo: postSubtitle,
          descripcion: postDescription,
          InstitucionId: cookies.get("institucionid"),
        },
      );

      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "La descripción se guardó correctamente",
        timer: 2000,
        showConfirmButton: false,
      });

      setPostDescription("");
    } catch (error) {
      console.error("Error al crear", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data || "No se pudo guardar la descripción",
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <React.Fragment>
      <br />
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-5">
            <div className="card-body">
              <table className="table table-bordered" width="100%">
                <tbody>
                  <tr>
                    <td>
                      <h6 className="m-0 font-weight-bold text-primary">
                        SECCIÓN
                      </h6>
                      <br />
                      <select
                        style={selectStyle}
                        className="btn btn-secondary btn-user btn-block text-left"
                        onChange={(e) => setCountryId(e.target.value)}
                        value={countryId}
                      >
                        <option value="">Seleccione</option>
                        {country.map(({ id, titulo }) => (
                          <option
                            key={id}
                            value={id}
                            title={titulo} // tooltip
                          >
                            {titulo}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 className="m-0 font-weight-bold text-primary">
                        TÍTULO
                      </h6>
                      <br />
                      <select
                        style={selectStyle}
                        className="btn btn-secondary btn-user btn-block text-left"
                        onChange={(e) => setTitleId(e.target.value)}
                        value={titleId}
                        disabled={!countryId}
                      >
                        <option value="">Seleccione</option>
                        {titles.map(({ id, titulo }) => (
                          <option key={id} value={id} title={titulo}>
                            {titulo}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 className="m-0 font-weight-bold text-primary">
                        SUBTÍTULO
                      </h6>
                      <br />
                      <select
                        style={selectStyle}
                        className="btn btn-secondary btn-user btn-block text-left"
                        onChange={(e) => setPostSubtitle(e.target.value)}
                        value={postSubtitle}
                        disabled={!titleId}
                      >
                        <option value="">Seleccione</option>
                        {subtitles.map(({ id, subTitulo }) => (
                          <option key={id} value={id} title={subTitulo}>
                            {subTitulo}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h4>Ingrese aquí su descripción</h4>
                      <textarea
                        className="form-control"
                        rows="6"
                        onChange={(e) => setPostDescription(e.target.value)}
                        value={postDescription}
                        disabled={!postSubtitle}
                      ></textarea>
                    </td>
                  </tr>
                </tbody>
              </table>

              {postSubtitle && (
                <>
                  <AdjuntoAutoevaluacion
                    idSolicitud={cookies.get("institucionid")}
                    idSubtitulo={postSubtitle}
                  />
                  <center>
                    <hr />
                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={postData}
                      disabled={isSaving}
                    >
                      {isSaving ? "Guardando..." : "Guardar Descripción"}
                    </button>
                  </center>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PerfilAutoevaluacio;
